export const ROLE_AGENT = 'agent';
export const ROLE_DISTRIBUTOR = 'distributor';
export const ROLE_TECHINICIAN = 'technician';
export const ROLE_USER = 'user';
